import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

import Layout from "../../components/layout"
import SEO from "../../components/seo"

import "../../styles/work_details.scss";

const IndexPage = () => {
  const data = useStaticQuery(graphql`
    query {
      bgLogo: file(relativePath: { eq: "icon-bg.png" }) {
        childImageSharp {
          fluid(maxWidth: 500, maxHeight: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      slideshow1: file(relativePath: { eq: "works/cab/slideshow1.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000, maxHeight: 1500, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      slideshow2: file(relativePath: { eq: "works/cab/slideshow2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000, maxHeight: 1500, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      paper1: file(relativePath: { eq: "works/cab/paper1.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 550, maxHeight: 400, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      paper2: file(relativePath: { eq: "works/cab/paper2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 550, maxHeight: 400, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      paper3: file(relativePath: { eq: "works/cab/paper3.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 550, maxHeight: 400, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      paper4: file(relativePath: { eq: "works/cab/paper4.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 550, maxHeight: 400, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      wire1: file(relativePath: { eq: "works/cab/wire1.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 255, maxHeight: 450, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      wire2: file(relativePath: { eq: "works/cab/wire2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 255, maxHeight: 450, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      wire3: file(relativePath: { eq: "works/cab/wire3.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 255, maxHeight: 450, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      wire4: file(relativePath: { eq: "works/cab/wire4.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 255, maxHeight: 450, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      wire5: file(relativePath: { eq: "works/cab/wire5.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 255, maxHeight: 450, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      wire6: file(relativePath: { eq: "works/cab/wire6.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 255, maxHeight: 450, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      wire7: file(relativePath: { eq: "works/cab/wire7.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 255, maxHeight: 450, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      wire8: file(relativePath: { eq: "works/cab/wire8.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 255, maxHeight: 450, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      screen1: file(relativePath: { eq: "works/cab/screen1.png" }) {
        childImageSharp {
          fluid(maxWidth: 305, maxHeight: 600, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      screen2: file(relativePath: { eq: "works/cab/screen2.png" }) {
        childImageSharp {
          fluid(maxWidth: 305, maxHeight: 600, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      screen3: file(relativePath: { eq: "works/cab/screen3.png" }) {
        childImageSharp {
          fluid(maxWidth: 305, maxHeight: 600, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      screen4: file(relativePath: { eq: "works/cab/screen4.png" }) {
        childImageSharp {
          fluid(maxWidth: 305, maxHeight: 600, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      screen5: file(relativePath: { eq: "works/cab/screen5.png" }) {
        childImageSharp {
          fluid(maxWidth: 305, maxHeight: 600, fit: INSIDE) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Layout>
      <SEO title="Home" />
      <div className="hp-bg-img-container">
        <Img
          fluid={data.bgLogo.childImageSharp.fluid}
          imgStyle={{ objectFit: "contain" }}
        />
      </div>
      <div className="BannerContainer">
        <div className="hp-container hp-column" style={{ height: "100%" }}>
          <h5>Cabs (Own Concept)</h5>
          <h3>
            Provided an in cab experience for the passengers making their on
            going journey more enjoyable.
          </h3>
        </div>
      </div>
      <div className="SlideShowContainer">
        <Img fluid={data.slideshow1.childImageSharp.fluid} />
      </div>
      <div className="OverviewContainer">
        <div className="hp-container hp-justify-between">
          <h3>Overview</h3>
          <div className="OverviewContent">
            <h4>
              With mobility services being a lucrative choice amongst people of
              all age groups, there are a plethora of opportunities to enrich
              the experience of a customer in a cab. From offering a snack or
              beverage from a place of their choice while onboarding to throwing
              trivia about important places in their route. Engaging the
              customer with a personal touch goes a long way. Movies, songs,
              books, and magazines will entertain the customer enough to make
              the entire journey feel like a breeze. And providing a coupon for
              shopping after a ride is another add-on that would keep the
              customers tied up even after a ride.
            </h4>
            <h4>
              With so much competition, it is always necessary to go on the
              extra mile by engaging the customer and gaining their attention in
              all three stages of the user journey - Before, while, and after
              opting for our service. This solution aims to achieve the same
              with an easy to use interface and seamless user experience.
            </h4>
          </div>
        </div>
      </div>
      <div className="SlideShowContainer">
        <Img fluid={data.slideshow2.childImageSharp.fluid} />
      </div>
      <div className="DesignProcessContainer">
        <div className="hp-container hp-justify-between">
          <h3>Design Process</h3>
          <div className="DesignProcessContent">
            <h4>
              User-Centered Design (UCD) is an interactive design process in
              which I focus on the user and their needs in each phase of the
              design process. At UCD, I involve users throughout the design
              process variety of research and design techniques, to create a
              highly usable and accessible product for them.
            </h4>
          </div>
        </div>
        <div className="hp-container hp-justify-between">
          <div className="ProcessGrid">
            <div className="IdeaButton">
              <h4>Discover</h4>
            </div>
            <div className="IdeaButton">
              <h4>Define</h4>
            </div>
            <div className="IdeaButton">
              <h4>Ideate</h4>
            </div>
            <div className="IdeaButton">
              <h4>Design</h4>
            </div>
          </div>
        </div>
      </div>
      <div className="UserFlowContainer">
        <div className="hp-container hp-justify-between">
          <h3>User flow</h3>
          <div className="UserFlowContent">
            <h4>
              There are many different pathways a user can take when interesting
              with a product. a user flow is a visual representation, either
              written out or made digitally, of many avenues that can be taken
              when using an app.
            </h4>
          </div>
        </div>
      </div>
      <div className="PaperSketchContainer">
        <div className="hp-container hp-justify-between">
          <h3>Paper Sketch</h3>
          <div className="PaperSketchContent">
            <h4>
              They are typically concept sketches, a set of drawings of
              storyboard, representing the skeleton of the interface. The next
              level up is a low fidelity wirefram. Low fidelity wireframes
              incule the most basic content and visuals and are usually static
              (not interactive)
            </h4>
          </div>
        </div>
        <div className="hp-container hp-justify-between">
          <div className="GridContainer">
            <div className="ImageContainer">
              <Img
                fluid={data.paper1.childImageSharp.fluid}
                imgStyle={{ objectFit: "cover" }}
              />
            </div>
            <div className="ImageContainer">
              <Img fluid={data.paper2.childImageSharp.fluid} />
            </div>
            <div className="ImageContainer">
              <Img fluid={data.paper3.childImageSharp.fluid} />
            </div>
            <div className="ImageContainer">
              <Img fluid={data.paper4.childImageSharp.fluid} />
            </div>
          </div>
        </div>
      </div>
      <div className="WireframeContainer">
        <div className="hp-container hp-column">
          <h3>Wireframe</h3>
          <div className="WireframeGridContainer">
            {new Array(8).fill(0).map((_, index) => (
              <div className="WireframeImageContainer">
                <Img fluid={data[`wire${index + 1}`].childImageSharp.fluid} />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="MobileScreensContainer">
        <div className="hp-container hp-column">
          <h3>Mobile Screens</h3>
          <div className="MobileScreensGridContainer">
            {new Array(5).fill(0).map((_, index) => (
              <div className="MobileScreenContent mobileScreenContent">
                <div className="MobileScreensImageContainer">
                  <Img
                    fluid={data[`screen${index + 1}`].childImageSharp.fluid}
                  />
                </div>
                <h5>User Decision</h5>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="PrototypeContainer">
        <div className="hp-container hp-column">
          <h3>Prototype</h3>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.figma.com/proto/at30lZ4Wdk0Mb2lZswolPm/Trimble-Design-Task?node-id=34%3A0&viewport=-1634%2C-790%2C1&scaling=scale-down"
          >
            Figma
          </a>
        </div>
      </div>
    </Layout>
  )
}

export default IndexPage
